import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const serviceDeskChatNextGenRedirect = ({ match }: RouteContext) => {
	const { projectKey } = match.params;
	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;

	return <Redirect to={url} />;
};
